module.exports = __webpack_public_path__ + "img/bg.4f538941.png";